export const confirmInfoMsg = {
  textLabel:
    'We have just sent you a confirmation email, complete your registration there',
  titleButton: 'Ok',
};
